// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  DOWNLOAD_GENERAL_DATA,
  SUCCESS_DOWNLOAD_GENERAL_DATA,
  ERROR_DOWNLOAD_GENERAL_DATA,
  PLAY_SOUND,
  SHOW_LOADER,
  SET_CURRENT_OFFERING
} from '../types/index'



// State Reducer
const initialState = {
  error: false,
  isLoad: false,
  header: {},
  footer: {
    sound: {
      icon: {
        url: '',
        alt: ''
      },
      text: '',
      url: ''
    },
    socials: '',
    text: '',
    menu: []
  },
  currentOffering: {
    idOffering: 0,
    name: '',
    age: '',
    photo: '',
    dedicatedText: '',
    dedicatedBy: ''
  },
  isPlayedSound: false
}



// Reducer
export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case SHOW_LOADER:
      return {
        ...state,
        isLoad: action.payload
      }
    case DOWNLOAD_GENERAL_DATA:
      return {
        ...state,
        isLoad: true

      }
    case SUCCESS_DOWNLOAD_GENERAL_DATA:
      const headerData = action.payload.header
      const footerData = action.payload.footer
      return {
        ...state,
        header: headerData,
        footer: {
          sound: {
            icon: {
              url: footerData.audio_logo.url,
              alt: footerData.audio_logo.alt
            },
            text: footerData.audio.description,
            url: footerData.audio.url
          },
          socials: footerData.social,
          text: footerData.text,
          menu: footerData.menu_footer
        },
        isLoad: false,
        error: false
      }
    case ERROR_DOWNLOAD_GENERAL_DATA:
      return {
        ...state,
        error: true,
        isLoad: false
      }
    case SET_CURRENT_OFFERING:
      return {
        ...state,
        currentOffering: action.payload
      }
    case PLAY_SOUND:
      return {
        ...state,
        isPlayedSound: action.payload
      }
    default:
      return {
        ...state
      }
  }
}
